import { colors, fontSizes, radii, zIndices } from '@marvelapp/theme';
import { hexToRGB } from '../utils';
export function getTooltipStyle({ arrowRight, cursor, display, fontSize = fontSizes[1], fontWeight, maxWidth, padding = '6px 10px 4px', pointerEvents, position, whiteSpace = 'nowrap', width, }) {
    const extraArrowStyles = arrowRight && { right: arrowRight };
    return {
        wrapper: {
            cursor,
            display,
            fontWeight,
            zIndex: 'unset',
        },
        content: {
            backgroundColor: 'transparent',
            color: colors.white,
            display: 'block',
            fontSize,
            lineHeight: 1.5,
            padding: 0,
            whiteSpace,
            width,
            maxWidth,
        },
        tooltip: Object.assign({ backgroundColor: hexToRGB(colors.licorice, 0.9), borderRadius: radii[1], display: 'block', margin: 0, minWidth: 0, zIndex: zIndices.tooltip, padding,
            pointerEvents }, position.tooltip),
        arrow: Object.assign(Object.assign({}, position.arrow), extraArrowStyles),
        gap: Object.assign({}, position.gap),
    };
}
